/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	const tabChange = () => {
		let pos;
		$('.recruit-tabWrapTop .recruit-tab-child').click(function(){
			$('.recruit-tab-child').removeClass(a);
			$('.recruit-tabBlock-child').removeClass(a);
			$(this).addClass(a);
			const index = $(this).index();
			$('.recruit-tabBlock-child').eq(index).addClass(a);
			$('.recruit-tabWrapBottom .recruit-tab-child').eq(index).addClass(a);
			pos = $('.recruit-tabWrapTop').offset().top;
			pos -= 60;
			$('html,body').stop().animate({ scrollTop: pos }, 400, 'easeOutExpo');
		});
		$('.recruit-tabWrapBottom .recruit-tab-child').click(function(){
			$('.recruit-tab-child').removeClass(a);
			$('.recruit-tabBlock-child').removeClass(a);
			$(this).addClass(a);
			const index = $(this).index();
			$('.recruit-tabBlock-child').eq(index).addClass(a);
			$('.recruit-tabWrapTop .recruit-tab-child').eq(index).addClass(a);
			pos = $('.recruit-tabWrapTop').offset().top;
			pos -= 60;
			$('html,body').stop().animate({ scrollTop: pos }, 400, 'easeOutExpo');
		});
		// sp時横スクロール連動
		let scrolling = false;
		const tableHead = $('.recruit-tabWrapTop .mod-auto');
		const tableBody = $('.recruit-tabWrapBottom .mod-auto');
		tableHead.scroll(function(){
			if(scrolling) {
				scrolling = false;
				return true;
			}
			scrolling = true;
			tableBody.scrollLeft(tableHead.scrollLeft());
		});
		tableBody.scroll(function(){
			if(scrolling) {
				scrolling = false;
				return true;
			}
			scrolling = true;
			tableHead.scrollLeft(tableBody.scrollLeft());
		});
	};

	tabChange();

})(window.jQuery, window.FUNCTIONS);
